import {announce} from '@github-ui/aria-live'
import {useEffect} from 'react'

export function AgentsWorkbenchLoadingState() {
  useEffect(() => {
    announce('Loading task…')
  }, [])

  return <p className="p-4 color-fg-muted">Loading task…</p>
}
